import { colors } from '@mehilainen/mds-tokens';
// NOTE: Do not import these from lib root (src/index)! Will cause circular deps
/**
 * `.Mui-focusVisible` CSS class for focus styles if keyboard focused
 *
 * ---
 * **NOTE**: `.Mui-focusVisible` CSS class is applied to the root element if keyboard focused.
 * Some elements (e.g. Chip) have this class available by default but e.g. Button
 * (and elements that inherit BaseButton) get this class only when `disableRipple` prop is true.
 *
 * {@link https://mui.com/material-ui/api/button-base/ Check disableRipple description for MUI BaseButton}
 */
export const muiFocusVisibleCssClass = '[class*="Mui-focusVisible"]';
export const focusVisible = {
    outlineOffset: '2px',
    outlineColor: colors.Info600,
    outlineWidth: '2px',
    outlineStyle: 'solid',
    boxShadow: 'unset !important',
};
